// removed by extract-text-webpack-plugin
module.exports = {"card":"Project__card___jj3MN","cardHeader":"Project__cardHeader___2U3xZ","cardText":"Project__cardText___20EZS"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/ProjectDetail/components/Project.scss
// module id = 1221
// module chunks = 1